import script from "./ZoomDisconnectPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ZoomDisconnectPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ZoomDisconnectPopup.vue?vue&type=style&index=0&id=12cb487b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12cb487b"]])

export default __exports__